if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;

        const linesUpdateDeferred =
          this.createCartLinesUpdateEvent(
            variantId,
            quantity
          );

        /*
         * BOX FREE GRIP TAPE
         */

        const BOX_GRIP_VARIANT_ID = '42010279346276';

        const BOX_DECK_PRODUCT_IDS = new Set([
          '7543194419300',
          '7716770447460',
          '7716763402340',
          '7201079394404',
          '7468943442020',
          '8039317667940',
          '7135662440548',
          '8121632686180',
          '6956259737700',
          '6956265898084',
          '7135660408932',
          '8058352566372',
          '6956263866468',
          '8527966830692',
          '6956254593124',
          '7287478124644',
          '6814534303844',
          '7201079558244',
          '6814535549028',
          '7391969673316'
        ]);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())

          .then(async (response) => {
            /*
             * Normal Shopify error handling
             */

            if (response.status) {
              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',
                  productVariantId: variantId,
                  errors:
                    response.errors ||
                    response.description,
                  message:
                    response.message,
                }
              );

              this.handleErrorMessage(
                response.description
              );

              this.dispatchCartErrorEvent(
                response.description ||
                  response.message,
                'INVALID'
              );

              linesUpdateDeferred?.reject(
                new Error(
                  response.description ||
                    response.message
                )
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) return;

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButtonText.classList.add(
                'hidden'
              );

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            }

            /*
             * response is the deck/product Shopify
             * just successfully added.
             */

            let finalResponse = response;

            const productId =
              String(response.product_id || '');

            const isBoxDeck =
              BOX_DECK_PRODUCT_IDS.has(productId);

            /*
             * If a deck was added, make a SECOND
             * normal Shopify cart/add request for
             * the free grip tape.
             *
             * We request cart sections again here.
             * Those sections are rendered AFTER
             * both items exist in the cart.
             */

            if (isBoxDeck) {
              try {
                const gripConfig =
                  fetchConfig('javascript');

                gripConfig.headers[
                  'X-Requested-With'
                ] = 'XMLHttpRequest';

                delete gripConfig.headers[
                  'Content-Type'
                ];

                const gripFormData =
                  new FormData();

                gripFormData.append(
                  'id',
                  BOX_GRIP_VARIANT_ID
                );

                gripFormData.append(
                  'quantity',
                  quantity
                );

                /*
                 * Hidden line-item property.
                 * Shopify/Dawn hides properties
                 * beginning with "_".
                 */
                gripFormData.append(
                  'properties[_box_free_grip]',
                  'true'
                );

                if (this.cart) {
                  gripFormData.append(
                    'sections',
                    this.cart
                      .getSectionsToRender()
                      .map(
                        (section) =>
                          section.id
                      )
                  );

                  gripFormData.append(
                    'sections_url',
                    window.location.pathname
                  );
                }

                gripConfig.body =
                  gripFormData;

                const gripFetchResponse =
                  await fetch(
                    `${routes.cart_add_url}`,
                    gripConfig
                  );

                const gripResponse =
                  await gripFetchResponse.json();

                if (
                  !gripFetchResponse.ok ||
                  gripResponse.status
                ) {
                  console.error(
                    'BOX: deck added, but free grip tape could not be added.',
                    gripResponse
                  );
                } else {
                  /*
                   * This response contains fresh
                   * cart-drawer + cart-icon HTML
                   * after BOTH items were added.
                   */
                  finalResponse =
                    gripResponse;
                }
              } catch (gripError) {
                console.error(
                  'BOX: free grip tape add failed.',
                  gripError
                );
              }
            }

            /*
             * Preserve Dawn's original behavior.
             */

            if (!this.cart) {
              this.resolveCartLinesUpdate(
                linesUpdateDeferred
              );

              window.location =
                window.routes.cart_url;

              return;
            }

            this.resolveCartLinesUpdate(
              linesUpdateDeferred
            );

            const startMarker =
              CartPerformance.createStartingMarker(
                'add:wait-for-subscribers'
              );

            if (!this.error) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',
                  productVariantId:
                    variantId,
                  cartData:
                    finalResponse,
                }
              ).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });
            }

            this.error = false;

            /*
             * Collection-page Quick Add.
             */

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(
                          finalResponse
                        );
                      }
                    );
                  });
                },
                {
                  once: true
                }
              );

              quickAddModal.hide(true);
            }

            /*
             * Product page / direct Add to Cart.
             */

            else {
              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(
                    finalResponse
                  );
                }
              );
            }
          })

          .catch((e) => {
            console.error(e);

            this.dispatchCartErrorEvent(
              e.message ||
                'Network error',
              'SERVICE_UNAVAILABLE'
            );

            linesUpdateDeferred?.reject(
              e
            );
          })

          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            if (spinner) {
              spinner.classList.add(
                'hidden'
              );
            }

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          });
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(
        variantId,
        quantity
      ) {
        const {
          CartLinesUpdateEvent
        } =
          window.StandardEvents || {};

        if (!CartLinesUpdateEvent) {
          return null;
        }

        const deferred =
          CartLinesUpdateEvent.createPromise();

        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action:
              'add',

            context:
              'product',

            lines: [
              {
                merchandiseId:
                  variantId,
                quantity
              }
            ],

            promise:
              deferred.promise,
          })
        );

        return deferred;
      }

      resolveCartLinesUpdate(
        deferred
      ) {
        if (!deferred) return;

        const {
          CartLinesUpdateEvent
        } =
          window.StandardEvents || {};

        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise =
          typeof CartItems !==
          'undefined'
            ? CartItems.fetchCartData()
            : fetch(
                `${routes.cart_url}.json`
              ).then(
                (response) =>
                  response.json()
              );

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) {
              return deferred.reject(
                new Error(
                  'Missing currency in cart response'
                )
              );
            }

            deferred.resolve({
              cart:
                CartLinesUpdateEvent
                  .createCartFromAjaxResponse(
                    cart
                  ),
            });
          })
          .catch(
            (e) =>
              deferred.reject(e)
          );
      }

      dispatchCartErrorEvent(
        message,
        code
      ) {
        const {
          CartErrorEvent
        } =
          window.StandardEvents || {};

        if (!CartErrorEvent) return;

        this.dispatchEvent(
          new CartErrorEvent({
            error:
              message,
            code
          })
        );
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}